module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Route-540f799cb25c457ba93331a0f42a54cc.svg";